var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5972_6234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13.5H8.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5C14 14.0304 13.7893 14.5391 13.4142 14.9142C13.0391 15.2893 12.5304 15.5 12 15.5H4C3.46957 15.5 2.96086 15.2893 2.58579 14.9142C2.21071 14.5391 2 14.0304 2 13.5C2 12.9696 2.21071 12.4609 2.58579 12.0858C2.96086 11.7107 3.46957 11.5 4 11.5H12C12.5304 11.5 13.0391 11.7107 13.4142 12.0858C13.7893 12.4609 14 12.9696 14 13.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 9.49987C12.4893 9.50006 12.9713 9.38053 13.4039 9.15169C13.8365 8.92285 14.2065 8.59165 14.4818 8.18698C14.757 7.78231 14.929 7.31646 14.9829 6.83004C15.0367 6.34362 14.9708 5.85142 14.7908 5.39634C14.6107 4.94126 14.3221 4.53713 13.9501 4.21919C13.578 3.90126 13.1339 3.67916 12.6563 3.57229C12.1787 3.46541 11.6822 3.47699 11.2102 3.60601C10.7381 3.73504 10.3047 3.9776 9.94791 4.31254C9.81658 3.4618 9.44403 2.66657 8.87444 2.02116C8.30485 1.37574 7.56211 0.907206 6.73431 0.671116C5.9065 0.435026 5.02836 0.441284 4.204 0.689149C3.37965 0.937013 2.64367 1.41609 2.08333 2.06956C1.523 2.72303 1.16182 3.52348 1.04263 4.376C0.923431 5.22852 1.05122 6.09734 1.41084 6.87944C1.77046 7.66153 2.34682 8.32409 3.07158 8.78854C3.79635 9.253 4.6391 9.49986 5.49991 9.49987H11.9999Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5972_6234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudStatus);
export default __webpack_public_path__ + "static/media/cloud_status.e42b0fae.svg";
export { ForwardRef as ReactComponent };